module.exports = __webpack_public_path__ + "img/6.226c7fea.jpg";